module.exports = __webpack_public_path__ + "img/webzi.dd2edbc7.png";